import { ChangeDetectionStrategy, Component, ElementRef, inject, input, linkedSignal, output, signal } from '@angular/core';
import { Icon } from '../icon/icon';
import { Language } from '@concretecode/shared';

interface LangOption {
  code: Language;
  flag: string;
  label: string;
}

@Component({
  selector: 'lib-language-switcher',
  imports: [Icon],
  templateUrl: './language-switcher.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:click)': 'onDocumentClick($event)',
  },
})
export class LanguageSwitcher {
  readonly #elRef = inject(ElementRef);

  public readonly inputLanguage = input<Language>('en');
  public readonly languageChanged = output<Language>();

  protected readonly lang = linkedSignal<Language>(() => this.inputLanguage());
  protected readonly isOpen = signal(false);

  protected readonly languages: LangOption[] = [
    { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
    { code: 'en', flag: '🇬🇧', label: 'English' },
    { code: 'fr', flag: '🇫🇷', label: 'Français' },
    { code: 'it', flag: '🇮🇹', label: 'Italiano' },
  ];

  protected toggleOpen(): void {
    this.isOpen.update((v) => !v);
  }

  protected selectLang(lang: Language): void {
    this.lang.set(lang);
    this.languageChanged.emit(lang);
    this.isOpen.set(false);
  }

  protected onDocumentClick(event: Event): void {
    if (!this.#elRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
